<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile/>
      <b-link class="navbar-brand" to="/">
        <img class="navbar-brand-full" height="55" src="../assets/logo.svg"  alt="CoreUI Logo">
        <img class="navbar-brand-minimized" src="../assets/logo-icon.svg" width="30" height="30" alt="CoreUI Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />

      <!-- <b-navbar-nav class="">
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
      </b-navbar-nav> -->
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item class="d-md-down-none">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger">5</b-badge>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-list"></i>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-location-pin"></i>
        </b-nav-item> -->
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="http://site.vaultid.com.br/">VaultID</a>
        <span class="ml-1">&copy; {{(new Date()).getFullYear()}} </span>
        <b-badge variant="secondary" style="cursor: pointer" v-b-modal.modal-version>v.{{version.tag}}</b-badge>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="http://site.vaultid.com.br/">VaultID</a>
      </div>
    </TheFooter>
    <b-modal id="modal-version" ok-only ref="modal" title="Informações da Versão">
      <pre>{{ JSON.stringify(version, null, 4) }}</pre>
    </b-modal>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
import _ from 'underscore'
import { env } from '@/shared/utils';
import axios from 'axios';
import Vue from 'vue'

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    var itms = nav.items;
    var validateRole = function(role) {
      let andRoles = role.and || [];
      for (const role of andRoles) {
        if (_.isObject(role)) {
          if (!validateRole(role)) {
            return false;
          }
        } else if (!JSON.parse(localStorage.roles).includes(role)) {
          return false;
        }
      }
      let orRoles = role.or || [];
      for (const role of orRoles) {
        if (_.isObject(role)) {
          if (validateRole(role)) {
            return true;
          }
        } else if (JSON.parse(localStorage.roles).includes(role)) {
          return true;
        }
      }
      if (orRoles.length > 0) {
        return false;
      }
      return true;
    }
    var isAllowed = function(navItem) {
      if (!navItem.role) {
        return true;
      }
      let role = navItem.role;
      if (typeof navItem.role === "string") {
        role = {
          and: [navItem.role]
        }
      }
      return validateRole(role);
    }
    var filterNavItems = function(navItems) {
      var items = _.filter(navItems, (itm) => isAllowed(itm));
      items.forEach(itm => {
        if (itm.children) {
          itm.children = filterNavItems(itm.children);
        }
      });
      return items;
    }
    if (localStorage.roles && JSON.parse(localStorage.roles).length) {
      itms = filterNavItems(nav.items);
    }
    return {
      nav: itms,
      version: env.version
    }
  },
  mounted() {
    axios
      .get(`${env.urlBillingApi}/version`)
      .then((response) => {
        Vue.set(this.version, 'server', response.data);
      }).catch(console.error);
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  }
}
</script>
<style lang="scss" scoped>
.app-header {
  background-color: #DFE2ED;
  border-bottom: 1px solid #DFE2ED;
  -webkit-box-shadow: 0px 6px 15px -1px rgba(0,0,0,0.41);
  -moz-box-shadow: 0px 6px 15px -1px rgba(0,0,0,0.41);
  box-shadow: 0px 6px 15px -1px rgba(0,0,0,0.41);
}
button:focus {
  outline: 1px dotted;
  outline: 0px auto -webkit-focus-ring-color;
}
.sidebar .nav-link .active {
  background: #5500AF !important;
  background-color: #5500AF !important;
}

</style>
